<template>
  <BittsLayout :is-page="true">
    <template #content>
      <PageTitle title="My Team" />
      <TeamCounter v-if="!hasNewTeamPage">
        <SupernodeSeatCallout v-if="isSupernodeTier" />
      </TeamCounter>
      <TeamCounterNew v-else />
      <TeamTablesWrapper :has-new-team-page />
      <router-view-wrapper />
      <!-- Invite Modal -->
    </template>
  </BittsLayout>
</template>

<script setup>
import { BittsLayout } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import SupernodeSeatCallout from '@/components/billing/SupernodeSeatCallout.vue';
import PageTitle from '@/components/PageTitle.vue';
import TeamCounter from '@/components/team/TeamCounter.vue';
import TeamCounterNew from '@/components/team/TeamCounterNew.vue';
import TeamTablesWrapper from '@/components/team/TeamTablesWrapper.vue';

import { TEMP_NEW_TEAM_PAGE } from '@/constants/feature_flags';
import {
  useBillingStore,
  useFeatureFlagStore,
  useFlashesStore,
} from '@/stores';

const billingStore = useBillingStore();
const { isSupernodeTier } = storeToRefs(billingStore);

useHead({ title: 'Team - Crossbeam' });
const route = useRoute();
const flashesStore = useFlashesStore();
if (route.query.downgrade_complete) {
  flashesStore.addSuccessFlash({
    message: 'Team successfully updated',
    description: 'Thanks for making these selections',
  });
}

const ffStore = useFeatureFlagStore();
const hasNewTeamPage = computed(() =>
  ffStore.hasFeatureFlag(TEMP_NEW_TEAM_PAGE),
);
</script>
